import { register } from 'register-service-worker';
import { createApp } from 'vue';
import App from './App.vue';

import router from './router';
import store from './store';

import clickOutside from './directives/click-outside';
import checkPerm from './directives/perm';

import './index.css';

// directives
const savedTheme = localStorage.getItem('theme') || 'dark';
document.documentElement.classList.toggle('light', savedTheme === 'light');

store.watch(
  (state) => (state as any).theme.theme,
  (newTheme) => {
    document.documentElement.classList.toggle('light', newTheme === 'light');
  },
  { immediate: true },
);

if (process.env.NODE_ENV === 'production') {
  register('/service-worker.js', {
    ready() {
      console.log('Offline ready');
    },
    registered() {
      console.log('Service worker registered');
    },
    cached() {
      console.log('Content cached');
    },
  });
}

createApp(App)
  .use(store)
  .use(router)
  .use(clickOutside)
  .use(checkPerm)
  .mount('#app');
